module.exports = __webpack_public_path__ + "img/enroll.688728a4.svg";